module.exports = __webpack_public_path__ + "img/milestone__1872.73964ea7.jpg";